// src/components/Loader.jsx
import React from 'react';
import '../styles/styles.css';
import Logo from '../assets/images/logo.png'; 

const Loader = () => {
  return (
    <div className="loader-overlay">
      <img src={Logo} alt="Logo cargando..." className="loader-logo" />
    </div>
  );
};

export default Loader;
